import React from 'react'
import { PrismicRichText} from '@prismicio/react'

const AllContentDescription = ({ pageDescription }) => {
  if(pageDescription === null || pageDescription.length === 0) return null
   return (
      <PrismicRichText field={pageDescription} /> 
   )
}
const AllContentPageInfo = ({ pageInfo}) => {
  if(!pageInfo) return null;
    return ( 
      <div data-wio-id={pageInfo.id} > 
        <h1 className="pb-2"> {pageInfo.data.page_title.text ? pageInfo.data.page_title.text : "Untitled"}</h1> 
        <div>
         <AllContentDescription pageDescription={pageInfo.data.page_description.raw}/>
        </div>
      </div>
    );
  };

  export default AllContentPageInfo;